module.exports = __webpack_public_path__ + "img/PYF.b23f6154.svg";